var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
export var DescriptionListMultiCol = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    var pairs = [];
    React.Children.forEach(children, function (child, i) {
        var j = i % 2;
        if (j === 0) {
            pairs.push([]);
        }
        pairs[Math.floor(i / 2)][j] = child;
    });
    return (React.createElement("dl", __assign({ className: classNames('ffe-description-list-multicol', className) }, rest), pairs.map(function (pair, idx) { return (React.createElement("div", { className: "ffe-description-list-multicol__avoid-break", key: idx },
        pair[0],
        pair[1])); })));
};
